module.exports = __webpack_public_path__ + "assets/skill.9842762c.svg";